import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

export function userinfoData(data){//用户基本信息
	return request.post(config.baseApi+"/merchant/basinessuserinfo",data)
}
/**
 * 订单管理
 */
export function orderManageList(data){//获取我的订单列表
	return request.get(config.baseApi+"/merchant/OrderManage/list",data)
}
export function orderManageAddressInfo(data){//查看收货人信息
	return request.get(config.baseApi+"/merchant/OrderManage/addressInfo",data)
}
export function orderManageShopList(data){//商家店铺列表
	return request.get(config.baseApi+"/merchant/OrderManage/orderManageShopList",data)
}
export function editSyncOrderQueue(data){//商家同步历史订单
	return request.post(config.baseApi+"/merchant/OrderManage/editSyncOrderQueue",data)
}
export function orderManageDetail(data){//订单详情
	return request.get(config.baseApi+"/merchant/OrderManage/detail",data)
}
export function orderManageFilterData(data){//获取订单筛选数据
	return request.post(config.baseApi+"/merchant/OrderManage/filterData",data)
}
export function orderManageBatPurchase(data){//手动批量采购
	return request.post(config.baseApi+"/merchant/OrderManage/batPurchase",data)
}
export function orderManageCheckAliOrderType(data){//批量采购检出
	return request.post(config.baseApi+"/merchant/OrderManage/checkAliOrderType",data)
}
export function orderManageBatAbnormal(data){//批量标记异常
	return request.post(config.baseApi+"/merchant/OrderManage/batAbnormal",data)
}
export function orderManageBatchMarkAbnormal(data){//批量标记/取消异常单
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageBatchMarkAbnormal",data)
}
export function orderManageBatchMarkException(data){//批量标记/取消异常订单(is_exception)
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageBatchMarkException",data)
}
export function orderManageMarkProblem(data){//标记问题订单
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageMarkProblem",data)
}
export function orderManageChangeSku(data){//关联商品
	return request.post(config.baseApi+"/merchant/OrderManage/changeOrderSku",data)
}
export function orderGetPddSkuInfo(data){//获取拼多多商品sku信息
	return request.get(config.baseApi+"/merchant/DdProduct/getPddSkuInfo",data)
}
export function orderManageRemarkInfo(data){//订单标记备注信息
	return request.get(config.baseApi+"/merchant/OrderManage/remarkInfo",data)
}
export function orderManageAddRemark(data){//添加备注和旗子
	return request.post(config.baseApi+"/merchant/OrderManage/addRemark",data)
}
export function orderManageServiceRemarkInfo(data){//订单客服备注信息
	return request.get(config.baseApi+"/merchant/OrderManage/serviceRemarkInfo",data)
}
export function orderManageAddServiceRemark(data){//添加客服备注
	return request.post(config.baseApi+"/merchant/OrderManage/addServiceRemark",data)
}
export function orderManageDeleteProduct(data){//删除
	return request.post(config.baseApi+"/merchant/OrderManage/deleteProduct",data)
}
export function orderManageReceipt(data){//确认收货
	return request.post(config.baseApi+"/merchant/OrderManage/receipt",data)
}
export function orderManageDelPddOrder(data){ //取消采购
	return request.post(config.baseApi+"/merchant/OrderManage/delPddOrder",data)
}
export function orderManageSendGiftOrder(data){//发送礼品单
	return request.post(config.baseApi+"/merchant/OrderManage/setOrderSendGift",data)
}
export function orderManageSetNotDealOrder(data){//完结订单
	return request.post(config.baseApi+"/merchant/OrderManage/setNotDealOrder",data)
}
export function orderManageRepealPurchase(data){//重新采购
	return request.post(config.baseApi+"/merchant/OrderManage/repealPurchase",data)
}
export function orderManageNeedSyncPddOrder(data){//同步采购
	return request.post(config.baseApi+"/merchant/OrderManage/needSyncPddOrder",data)
}
export function orderManageUpdateOrderAfterSale(data){//同步抖店
	return request.post(config.baseApi+"/merchant/OrderManage/updateOrderAfterSale",data)
}
export function orderManageCancelDelete(data){//恢复
	return request.post(config.baseApi+"/merchant/OrderManage/cancelDelete",data)
}
export function opDoOrderPay(data){//采购订单支付
	return request.post(config.baseApi+"/merchant/OrderManage/doOrderPay",data)
}
export function ddShopRefreshDecrypt(data){//提额成功更新店铺状态
	return request.get(config.baseApi+"/merchant/DdShop/refreshDecrypt",data)
}
export function unDecrypt(data){//放弃解密
	return request.get(config.baseApi+"/merchant/OrderManage/unDecrypt",data)
}
export function reDecrypt(data){//恢复解密
	return request.get(config.baseApi+"/merchant/OrderManage/reDecrypt",data)
}
export function decrypt(data){//解密单个订单
	return request.get(config.baseApi+"/merchant/OrderManage/decrypt",data)
}
export function refreshReturnAddress(data){//重新获取地址
	return request.post(config.baseApi+"/merchant/OrderManage/refreshReturnAddress",data)
}
export function setSellerWords(data){//商家留言
	return request.post(config.baseApi+"/merchant/OrderManage/setSellerWords",data)
}
export function updatePddAccount(data){//采购账号
	return request.post(config.baseApi+"/merchant/OrderManage/updatePddAccount",data)
}
export function updatePddOrderNo(data){//设置采购单号
	return request.post(config.baseApi+"/merchant/OrderManage/updatePddOrderNo",data)
}
export function updateOrderProduct(data){//商品编码
	return request.post(config.baseApi+"/merchant/OrderManage/updateOrderProduct",data)
}
export function updateBuyMode(data){//切换采购模式
	return request.post(config.baseApi+"/merchant/OrderManage/updateBuyMode",data)
}
export function baseConfig(data){//系统设置
	return request.get(config.baseApi+"/merchant/User/baseConfig",data)
}
export function checkPrintRecharge(data){//查询充值打单情况
	return request.post(config.baseApi+"/merchant/User/checkPrintRecharge",data)
}
export function editPrintProduct(data){//编辑打单商品配置
	return request.post(config.baseApi+"/merchant/User/editPrintProduct",data)
}
export function setAutoSendGift(data){//自动发礼品设置
	return request.post(config.baseApi+"/merchant/Mall/setAutoSendGift",data)
}
export function setAutoRefundReason(data){//更新商家自动退款原因配置
	return request.post(config.baseApi+"/merchant/User/updateAutoRefundReason",data)
}
export function setPddReturnAddress(data){//修改退货地址
	return request.post(config.baseApi+"/merchant/OrderManage/setPddReturnAddress",data)
}
export function searchAlibabaProductByImage(data){//图片搜索阿里巴巴商品
	return request.post(config.baseApi+"/merchant/Mall/mallSearchAlibabaProductByImage",data)
}
export function strategyDeleteSet(data){//获取策略删除设置
	return request.get(config.baseApi+"/merchant/OrderManage/orderManageGetStrategyDeleteSet",data)
}
export function editStrategyDeleteSet(data){//编辑策略删除设置
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageEditStrategyDeleteSet",data)
}
export function regionData(data){//获取省市区列表
	return request.get(config.baseApi+"/merchant/OrderManage/regionData",data)
}
export function ddReturnAddressInfo(data){ //抖店商品退货地址
	return request.get(config.baseApi+"/merchant/OrderManage/getDdReturnAddress",data)
}
export function editDdReturnAddress(data){ //编辑抖店商品退货地址
	return request.post(config.baseApi+"/merchant/OrderManage/editDdReturnAddress",data)
}
export function explainAddress(data){ //识别地址
	return request.get(config.baseApi+"/merchant/OrderManage/orderManageExplainAddress",data)
}
export function businessSetSyncReturnAddressType(data){//设置同步退货地址时机
	return request.post(config.baseApi+"/merchant/userBusinessSetSyncReturnAddressType",data)
}
export function addSyncDdOrderQueue(data) {//添加同步抖店订单队列
	return request.post(config.baseApi + "/merchant/OrderManage/orderManageAddSyncDdOrderQueue", data)
}
export function getAlibabaProductFilterTypeList(data){//获取1688精选货源商品筛选类型列表
	return request.get(config.baseApi+"/merchant/Mall/mallGetAlibabaProductFilterTypeList",data)
}
export function orderManageFetchAlibabaSendTime(data){//获取1688采购发货时间
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageFetchAlibabaSendTime",data)
}
export function orderManageDdLogisticsCompanies(data){//抖店快递公司列表
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageDdLogisticsCompanies",data)
}
export function orderManageManualDdDeliver(data){//手动发货
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageManualDdDeliver",data)
}
export function orderManageEditDdDeliverLogistics(data){//修改运单
	return request.post(config.baseApi+"/merchant/OrderManage/orderManageEditDdDeliverLogistics",data)
}

/**
 * 商品关联
 */
export function goodsRelativeInfoData(data){//获取关联商品信息
	return request.get(config.baseApi+"/merchant/DdProduct/relativeInfo",data)
}
export function goodsConfigData(data){//获取关联商品规格
	return request.get(config.baseApi+"/merchant/DdProduct/productSku",data)
}
export function submitRelative(data){//获取关联商品规格
	return request.post(config.baseApi+"/merchant/DdProduct/subSkuRelative",data)
}
export function submitPddSkuRelative(data){//提交pdd商品sku关联
	return request.post(config.baseApi+"/merchant/DdProduct/subPddSkuRelative",data)
}
export function similarGoodsData(data){//搜索同款商品
	return request.get(config.baseApi+"/merchant/DdProduct/searchProduct",data)
}
export function syncProduct(data){//一键同步商品
	return request.post(config.baseApi+"/merchant/DdProduct/syncProduct",data)
}
export function alibabaRelativeInfoData(data){//获取关联1688商品sku
	return request.get(config.baseApi+"/merchant/DdProduct/alibabaRelativeInfo",data)
}
export function alibabaSkuInfoData(data){//获取关联1688商品sku
	return request.get(config.baseApi+"/merchant/DdProduct/alibabaSkuInfo",data)
}
export function submitAlibabaSkuRelative(data){//提交1688商品sku关联
	return request.post(config.baseApi+"/merchant/DdProduct/subAlibabaSkuRelative",data)
}
export function syncDdProductInfo(data){ //同步抖店商品
	return request.get(config.baseApi+"/merchant/DdProduct/syncDdProductInfo",data)
}
export function alibabaSkuRelativeHistory(data){//历史关联1688商品规格记录
	return request.get(config.baseApi+"/merchant/DdProduct/productAlibabaSkuRelativeHistory",data)
}
export function querySkuRelativeInfo(data){//查询规格永久关联信息
	return request.get(config.baseApi+"/merchant/DdProduct/productQuerySkuRelativeInfo",data)
}
/**
 * 采购管理
 */
export function pddAccountList(data){//获取拼多多账号列表
	return request.post(config.baseApi+"/merchant/PddAccount/list",data)
}
export function checkIsOpenProtocolPay(data){//获取拼多多账号信息
	return request.post(config.baseApi+"/merchant/PddAccount/checkIsOpenProtocolPay",data)
}
export function pddAccountAdd(data){//添加拼多多账号
	return request.post(config.baseApi+"/merchant/PddAccount/add",data)
}
export function pddAccountDel(data){//删除拼多多账号
	return request.post(config.baseApi+"/merchant/PddAccount/delete",data)
}
export function pddAccountUpdate(data){//更新拼多多账号
	return request.post(config.baseApi+"/merchant/PddAccount/update",data)
}
export function pddAccountDefault(data){//设置拼多多默认账号
	return request.post(config.baseApi+"/merchant/PddAccount/default",data)
}
export function pddAccountSyncOrder(data){//获取拼多多账号信息
	return request.post(config.baseApi+"/merchant/PddAccount/syncOrder",data)
}
export function mallCateList(data){//获取拼多多账号信息
	return request.post(config.baseApi+"/merchant/Mall/cateList",data)
}


/**
 * 数据统计
 */
export function getStatisticData(data){
	return request.post(config.baseApi+"/merchant/ShopStatistic/index",data)
}

export function getStatisticRanking(data){
	return request.post(config.baseApi+"/merchant/ShopStatistic/getRanking",data)
}

export function getStatisticExpressData(data){
	return request.post(config.baseApi+"/merchant/ShopStatistic/getExpressData",data)
}

export function getStatisticProductDetailData(data){
	return request.post(config.baseApi+"/merchant/ShopStatistic/product_detail",data)
}

export function getStatisticShopProductRanking(data){
	return request.post(config.baseApi+"/merchant/ShopStatistic/getShopProductRanking",data)
}

export function getStatisticProductList(data){
	return request.post(config.baseApi+"/merchant/ShopStatistic/getProductList",data)
}


//售后管理
export function afterSalesfilterData(data){//筛选条件
	return request.get(config.baseApi+"/merchant/OrderManage/afterSalesFilterData",data)
}

export function orderAfterSalesList(data){ //售后列表
	return request.post(config.baseApi+"/merchant/OrderManage/afterSalesListData",data)
}
export function ddAftersaleBatchOperate(data){ //批量处理售后
	return request.post(config.baseApi+"/merchant/OrderManage/orderAfterSalesDdAftersaleBatchOperate",data)
}
export function ddAftersaleDetail(data){ //售后详情
	return request.post(config.baseApi+"/merchant/OrderManage/orderAfterSalesDdAftersaleDetail",data)
}
export function ddAftersaleOperate(data){ //售后处理
	return request.post(config.baseApi+"/merchant/OrderManage/orderAfterSalesDdAftersaleOperate",data)
}
export function ddAftersaleTimeExtend(data){ //延长收货
	return request.post(config.baseApi+"/merchant/OrderManage/orderAfterSalesDdAftersaleTimeExtend",data)
}
/** 抖店售后：申请物流拦截 afterSale/applyLogisticsIntercept */
export function ddAftersaleApplyLogisticsIntercept(data){
	return request.post(config.baseApi+"/merchant/OrderManage/orderAfterSalesDdAftersaleApplyLogisticsIntercept",data)
}
/** 抖店售后：合并当前单/策略/店铺的退货地址列表（见接口文档 ddReturnAddressList） */
export function ddReturnAddressList(data){
	return request.post(config.baseApi+"/merchant/OrderManage/orderAfterSalesDdReturnAddressList",data)
}

export function orderServerGetOperateInfo(data){//售后操作数据
	return request.get(config.baseApi+"/merchant/OrderManage/orderServerGetOperateInfo",data)
}
export function ddAftersaleAddRemark(data){ //售后备注
	return request.post(config.baseApi+"/merchant/OrderManage/orderAfterSalesDdAftersaleAddRemark",data)
}
export function uploadBasinessUpload(data){ //上传图片
	return request.post(config.baseApi+"/merchant/OrderManage/uploadBasinessUpload",data)
}
export function businessSetAftersaleConfig(data){ //售后设置
	return request.post(config.baseApi+"/merchant/userBusinessSetAftersaleConfig",data)
}


//售后地址
export function businessAddressInfo(data) {//商家地址（发货/售后）
	return request.get(config.baseApi + "/merchant/OrderManage/userBusinessAddress", data)
}

export function editBusinessAddress(data) {//商家地址（发货/售后）
	return request.post(config.baseApi + "/merchant/OrderManage/userEditBusinessAddress", data)
}
